import React from "react";

const PaperDarkBG = ({ children, className = "", fullHeight = false}) => {
  return (
    <div
      className={`${fullHeight ? "min-h-screen" : ""} w-full text-white ${className}`}
      style={{
        background: 'linear-gradient(180deg, #2a1035 0%, #141629 30%, #0b1020 100%)'
      }}
    >
      {children}
    </div>
  );
};

export default PaperDarkBG;
